/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




 $(function() {

   function announcement_height() {
    var height = 0;

    if( $('#section-announcement').length > 0 && $('#section-announcement').hasClass('announcement-bar-fixed')) {
      height = Math.floor($('#section-announcement').height());
    }

    if( height !== 0 && $('#shopify-section-announcement').length > 0 ) {
        $('#shopify-section-announcement').css('height', height + 'px' );
    }

    return height;
   }

   function announcement_height_gbp() {
    var height = 0;

    if( $('#section-announcement_gbp').length > 0 && $('#section-announcement_gbp').hasClass('announcement-bar-fixed')) {
      height = Math.floor($('#section-announcement_gbp').height());
    }

    if( height !== 0 && $('#shopify-section-announcement_gbp').length > 0 ) {
        $('#section-announcement_gbp').css('height', height + 'px' );
    }

    return height;
   }

   if ( announcement_height() > 0 ) {
     jQuery('#shopify-section-header').animate({ 'top':announcement_height() }, 300 );
   }

   if ( announcement_height_gbp() > 0 ) {
     jQuery('#shopify-section-header_gbp').animate({ 'top':announcement_height_gbp() }, 300 );
   }

   $(window).resize( function() {
     if ( announcement_height() > 0 ) {
       jQuery('#shopify-section-header').animate({ 'top':announcement_height() }, 300 );
     }

     if ( announcement_height_gbp() > 0 ) {
      jQuery('#shopify-section-header_gbp').animate({ 'top':announcement_height_gbp() }, 300 );
     }
   })


     $(document).on('click', '.product-modal', function (e) {
         e.preventDefault();
         $.fancybox.close();
         var url = $(this).attr('data-link');
         if( ! url ) {
             url = $(this).attr('href');
         }

         if(window.location.href.split("?").length >= 2 ){
             let href = window.location.href.split("?")[0];
             window.history.pushState({href: href}, '', href);
         }

         if (url) {
             $.fancybox.open(
                 {
                     src: url,
                     opts: {
                         type: 'ajax',
                         smallBtn: false,
                         baseClass: "fancybox-skin",
                         touch: false,
                         afterLoad: function (instance, current) {
                             setTimeout(function () {
                                 $(document).find('.fancybox-content').scrollTop(0);
                             }, 427);
                         },
                         beforeClose: function( e, instance ) {
                             if ( typeof window.languages.productFormAddToCartMain != 'undefined' ) {
                                 window.languages.productFormAddToCart = window.languages.productFormAddToCartMain;
                             }
                         }
                     }
                 }
             );
         }
         return false;
     });
 });
 
